export const devportalConfig = {
  assetId: '5693693421089207390',
  assetAlias: 'Intuit.spi.icn_client.2',
  service: 'cp-client',
  env: process?.env?.APP_ENV,
};
